import { BuildRulesetQuery } from '../../../interfaces/Rulesets';
import { extractJsonFieldSql } from '../../extractJsonFieldSql';

export const selectFields_ruleset3_PI_EV_EPIV: string = `
         CASE WHEN DN = 15 AND v100 between 0.3 * Vnom AND Vnom THEN 2
             WHEN DN > 15 AND DN <= 50 AND v100 between 0.5 * Vnom AND Vnom THEN 2
             WHEN DN > 50 AND DN <= 150 AND v100 between 0.6 * Vnom AND Vnom THEN 2
             WHEN DN > 150 AND v100 between 0 AND Vnom THEN 2
         ELSE 1 END as rank, id, label, attributes
`;

export const order_ruleset3_PI_EV_EPIV  = 'rank DESC, DN, Vnom, label';

export const buildQuery_ruleset3_PI_EV_EPIV: BuildRulesetQuery = ({
    selectFields,
    rawName,
    filter,
    volumetricFlow,
}): [string, string[]] =>  {
    return [
        `WITH 
    p as (SELECT
              coalesce(cast(attrsm3h.value as float), 0.0)  as Vnom,
              cast(attrs2.value as float) as DN,
              product.id,
              label,
              attributes
            FROM product
            JOIN bounds
            CROSS JOIN json_each(${extractJsonFieldSql('attributes', `$.15.${rawName}`)}) as attrs2
            CROSS JOIN json_each(${extractJsonFieldSql('attributes', `$.6943.${rawName}`)}) as attrsm3h
            WHERE ${filter}
            AND ${extractJsonFieldSql('attributes', `$.7266.${rawName}`)} in (
                '["Electronic pressure-independent characterised control valve"]',
                '["Pressure-independent Belimo Energy Valve™"]'
            )
            AND 
                CASE
                -- original regexp '[E][P,V][0][1-5][0,2,5][R][2,3][+](BAC|MID|KBAC)' converted to likes
                WHEN label like 'E%0%%R%+%'
                  AND substr(label, 2, 1) in ('P','V')
                  AND substr(label, 4, 1) in ('1','2','3','4','5')
                  AND substr(label, 5, 1) in ('0','2','5')
                  AND substr(label, 7, 1) in ('2','3')
                  AND substr(label, 9, 4) in ('BAC', 'MID', 'KBAC')
                THEN v100 between cast(floor(0.25 * Vnom * 10000) as float) / 10000 and Vnom
                ELSE v100 between cast(floor(0.3 * Vnom * 10000) as float) / 10000 and Vnom
                END
                )
     ,user_input as (SELECT cast(? as float) as v100)
     ,bounds as (SELECT v100, cast(floor(v100 * 1000 / 3.6) as float) / 1000 as v100LS,  v100 * 1000 as v100LH FROM user_input)
     SELECT
     ${selectFields} 
     FROM p
     JOIN bounds
`,
        [volumetricFlow]
    ];
}

